export default __webpack_public_path__ + "static/media/Template4.3576a73e.jpeg";